export const snakeCaseToTitleCase = (str: string) =>
  str
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/^./, s => s.toUpperCase())

export const pascalCaseToTitleCase = (str: string) =>
  str.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase())
